export const FILE_UPLOAD_SPEC =
  'specs.viewer-apps-813e0fc5-89be-48a2-89c0-5fd74d4beebd.FileUpload';
